// ── Spatial Approach Audio — soft harp chord on artwork proximity ──

let _audioCtx = null;

export const getAudioCtx = () => {
  if (!_audioCtx) {
    try { _audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch (_) { /* AudioContext non supporté */ }
  }
  return _audioCtx;
};

// Plays a delicate harp note — Mi majeur arpégé, ~0.8s, très doux et céleste
export const playApproachNote = () => {
  try {
    const ctx = getAudioCtx();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume();
    // Accord Mi majeur : E4, B4, E5, G#5 — arpège léger, très subtil
    const notes = [
      { freq: 329.63, gain: 0.016, delay: 0,    dur: 0.80, type: 'triangle' }, // E4  — base chaleureuse
      { freq: 493.88, gain: 0.011, delay: 0.04, dur: 0.85, type: 'triangle' }, // B4  — quinte
      { freq: 659.25, gain: 0.007, delay: 0.08, dur: 0.72, type: 'sine'     }, // E5  — octave brillante
      { freq: 830.61, gain: 0.004, delay: 0.13, dur: 0.60, type: 'sine'     }, // G#5 — reflet céleste
    ];
    notes.forEach(({ freq, gain, delay, dur, type }) => {
      const osc = ctx.createOscillator();
      const g   = ctx.createGain();
      osc.connect(g);
      g.connect(ctx.destination);
      osc.type = type;
      osc.frequency.value = freq;
      const t0 = ctx.currentTime + delay;
      g.gain.setValueAtTime(0, t0);
      g.gain.linearRampToValueAtTime(gain, t0 + 0.006); // attaque plus percussive
      g.gain.exponentialRampToValueAtTime(0.001, t0 + dur);
      osc.start(t0);
      osc.stop(t0 + dur + 0.04);
    });
  } catch (_) { /* Navigateur bloque l'audio : politique autoplay — résolu à la première interaction */ }
};
